import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Globe2 } from "lucide-react";
import { SITE } from "@/lib/site";

const links = [
  { id: "sobre", label: "Sobre" },
  { id: "credenciamentos", label: "Credenciamentos" },
  { id: "servicos", label: "Serviços" },
  { id: "processo", label: "Processo" },
  { id: "valores", label: "Valores" },
  { id: "contato", label: "Contato" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-[#E2E8F0] shadow-[0_1px_0_rgba(10,17,40,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-brand" className="flex items-center gap-3 group">
          <img
            src={SITE.media.logoMark}
            alt={`${SITE.brandName} — Tradutor Juramentado`}
            className="h-11 w-11 md:h-12 md:w-12 object-contain"
          />
          <span className="flex items-baseline gap-2">
            <span className="font-serif-display text-xl md:text-2xl tracking-tight text-[#0A1128]">
              {SITE.brandName}
            </span>
            <span className="hidden md:inline-block w-px h-4 bg-[#C5A059] mx-1" />
            <span className="hidden md:inline-block text-[10px] tracking-[0.25em] uppercase text-[#475569]">
              Tradutor Juramentado
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className="text-sm text-[#0A1128] hover:text-[#C5A059] transition-colors tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div
            id="google_translate_element"
            data-testid="google-translate"
            className="hidden md:flex items-center"
            aria-label="Trocar idioma"
          />
          <a
            href="#contato"
            data-testid="nav-cta"
            className="hidden md:inline-flex items-center gap-2 bg-[#0A1128] text-white text-sm px-5 py-3 rounded-sm hover:bg-[#16234D] transition-colors"
          >
            Solicitar Orçamento
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-[#0A1128]"
            aria-label="Abrir menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden bg-white border-t border-[#E2E8F0]"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.id}`}
                className="text-base text-[#0A1128] py-2 border-b border-[#E2E8F0]"
              >
                {l.label}
              </a>
            ))}
            <div id="google_translate_element_mobile" className="mt-2" />
            <a
              href="#contato"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="mt-2 inline-flex justify-center items-center gap-2 bg-[#0A1128] text-white text-sm px-5 py-3 rounded-sm"
            >
              Solicitar Orçamento
            </a>
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Navbar;
